// ============================================================
// computeSlippagePts — diferencia en PUNTOS entre el precio teorico
// (trigger del engine) y el fill real de Tradovate.
//
// Conventions del log [SLIPPAGE] de produccion (renFlowLive.js:3123-3126):
//   LONG  entrada favorable si trigger > fill   (compre mas barato)
//   LONG  salida favorable   si fill > trigger  (vendi mas caro)
//   SHORT invertido.
//
// Signo del resultado:
//   positivo (+pts) = slippage FAVORABLE acumulado entrada+salida
//   negativo (-pts) = slippage ADVERSO
//
// Trade abierto -> devolvemos solo entrySlip (no hay exit todavia).
// Cualquier campo faltante -> null (la UI muestra "—" en lugar de cero falso).
//
// Mantener en sync con el log de produccion. Si el bot cambia la formula,
// este helper hay que actualizarlo en lockstep o las dos visiones se
// desincronizan.
// ============================================================

export interface SlippageInput {
  side: 'long' | 'short' | null;
  entryTriggerPrice: number | null;
  entryPrice: number | null;
  exitTriggerPrice?: number | null;
  exitPrice?: number | null;
}

export function computeSlippagePts(t: SlippageInput): number | null {
  if (t.side == null || t.entryTriggerPrice == null || t.entryPrice == null) {
    return null;
  }

  const isLong = t.side === 'long';
  const entrySlip = isLong
    ? t.entryTriggerPrice - t.entryPrice
    : t.entryPrice - t.entryTriggerPrice;

  // Trade abierto: aun no hay exit. Solo reportamos entry slip.
  if (t.exitTriggerPrice == null || t.exitPrice == null) {
    return entrySlip;
  }

  const exitSlip = isLong
    ? t.exitPrice - t.exitTriggerPrice
    : t.exitTriggerPrice - t.exitPrice;

  return entrySlip + exitSlip;
}
